export default __webpack_public_path__ + "static/media/sec4-Img.51f449f8.png";